import { eRounding } from '../eRounding';
import {
  convertIRateConfigurationResponseToIRateConfigurationData,
  IRateConfigurationData,
  IRateConfigurationResponse,
} from './IRateConfiguration';
import {
  convertIRateConfigSelectorResponseToIRateConfigSelectorData,
  IRateConfigSelectorData,
  IRateConfigSelectorResponse,
} from './IRateConfigSelector';

export interface IPremiumConfigResponse {
  basicLenderRate?: IRateConfigurationResponse;
  rates: IRateConfigSelectorResponse[];
  amountRounding: eRounding;
  premiumRounding: eRounding;
  simultaneousIssuePremium?: number;
}

export interface IPremiumConfigData {
  basicLenderRate?: IRateConfigurationData;
  rates: IRateConfigSelectorData[];
  amountRounding: eRounding;
  premiumRounding: eRounding;
  simultaneousIssuePremium?: number;
}

export const convertIPremiumConfigResponseToIPremiumConfigData = ({
  basicLenderRate,
  rates,
  ...rest
}: IPremiumConfigResponse): IPremiumConfigData => ({
  ...rest,
  basicLenderRate: basicLenderRate
    ? convertIRateConfigurationResponseToIRateConfigurationData(basicLenderRate)
    : undefined,
  rates: rates.map(convertIRateConfigSelectorResponseToIRateConfigSelectorData),
});
